import { render } from "./Main.vue?vue&type=template&id=1af49226&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=1af49226&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1af49226"

export default script